<!-- 获奖记录 -->
<template>
  <popup-frame ref="records">
    <div :class="$style.records">
      <template v-if="list.length">
        <p style="text-align: center; font-size: 0.22rem;">
          游戏奖励将直接发送至绑定角色的游戏内游戏中<br />
          实体奖励将在活动结束后7个工作日内寄送
        </p>
        <div :class="$style['table-wrapper']">
          <table>
            <thead>
              <tr>
                <th>奖励名称</th>
                <th>获取时间</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(el, index) in list" :key="index">
                <td>
                  {{ el.award_name }}
                </td>
                <td>
                  {{ el.award_date }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <button
          v-if="hasTangiblePrize"
          :class="$style.address"
          @click="showAddress()"
        >
          {{
            Object.keys(addressData).length
              ? "邮寄地址已填写"
              : "填写我的邮寄地址"
          }}
        </button>
      </template>
      <div v-else :class="$style.empty" />
    </div>
  </popup-frame>
</template>

<script>
import { mapGetters } from "vuex";
import { fetchAwardRecord } from "@/api";
import { PopupFrame } from "@/components/widgets";

export default {
  name: "ThePrizeRecords",
  components: { PopupFrame },
  data() {
    return {
      list: [],
      /** 是否有实物奖励 */
      hasTangiblePrize: false
    };
  },
  computed: {
    ...mapGetters(["addressData"])
  },
  methods: {
    async showRecords() {
      const { data = {} } = await fetchAwardRecord();
      this.list = (data && data.list) || [];

      // 查询实物奖信息
      const prize = this.list.find(el => el.type === 2);
      this.hasTangiblePrize = !!prize;

      this.$refs.records.show();
    },
    show() {
      this.showRecords();
    },
    showAddress() {
      this.$emit("bind-address");
    }
  }
};
</script>

<style lang="less" module>
@item-height: 0.64rem;

.records {
  .size(6.8rem, 100%);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.1rem;
  margin: 0 auto;

  // 标题
  &::before {
    .size(4.91rem, 0.48rem);
    .background-fill("./images/records-title.png");

    content: "";
    display: block;
    margin: 0 auto;
  }

  .table-wrapper {
    max-height: @item-height * 4 + 0.03rem;
    overflow-y: auto;
    border: 0.02rem solid #bfa260;
  }

  table {
    width: 6.5rem;
    font-size: 0.28rem;
    border-collapse: collapse;

    th,
    td {
      .size(50%, @item-height);

      text-align: center;
      border: 0.02rem solid #bfa260;
    }

    th {
      border-top: 0;
    }

    tr:last-child td {
      border-bottom: 0;
    }
  }

  .empty {
    .size(2.23rem, 2.84rem);
    .background-fill("./images/empty.png");
    margin-top: 0.4rem;
  }
}

.address {
  padding-bottom: 0.05rem;
  font-size: 0.3rem;
  border-bottom: 1px solid #784831;
  align-self: center;
}
</style>
